import type { RootState } from '..';
import type { ThinkAlphaTourGuideStepsWithWidgetContext } from 'src/features/onboarding/types';

export const getWidgetTourSteps = (state: RootState): ThinkAlphaTourGuideStepsWithWidgetContext =>
    state.onboarding.tourGuideSteps;
